<template>
  <v-form>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          name="productName"
          outlined
          dense
          label="Product Name"
          v-model="record.Name"
          type="text"
          autocomplete="off"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field
          hide-details
          outlined
          dense
          label="Initial Empty Qty"
          v-model="record.InitialEmpty"
          type="number"
          autocomplete="off"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn
          v-if="docCreate == true"
          color="accent"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn
          v-else
          color="accent"
          @click="updateData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
export default {
  components: {},
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    record: {},
    searchingProduct: true,
    enableCreate: true,
    categoryDialog: false,
    brandDialog: false,
    newItem: {},
    loader: false,
    PriceUnit: null,
    categories: [],
    industries: [],
    showPricing: false,
    manualStatus: false,
    uoms: [],
    ougp: [],
    brands: [],
    stores: [],
    vendors: [],
    store: null,
    date: new Date().toISOString().substr(0, 10),
    itemTypes: [
      { name: "Inventory", value: "I" },
      { name: "Service Item", value: "S" },
      { name: "Delivery Charges", value: "C" },
    ],
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      if (this.docCreate == false) {
        if (val.ugpentry) {
          const manualType = val.ugpentry.IsManual;
          if (manualType == "Y") {
            this.showPricing = false;
            this.manualStatus = true;
          } else {
            this.showPricing = true;
            this.manualStatus = false;
            // get uom group uoms
            const self = this;
            this.$store
              .dispatch("get", `/ougp/${val.UgpEntry}`)
              .then((res) => {
                self.uoms = res.ResponseData.groupDef;
              })
              .catch((err) => {
                this.$refs.snackbar.show(err, "red");
              });
            // end
          }
        }
      }
      this.record = { ...val };
    },
    categoryModal() {
      this.categoryDialog = true;
    },
    brandModal() {
      this.brandDialog = true;
    },
    saveBrand(data) {
      const url = "/brands";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.brands = [...this.brands, res.ResponseData];
            self.record.brand_id = res.ResponseData.id;
            self.$refs.snackbar.show("Brand Added Successully", "green");
            self.brandDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            self.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    saveCategory(data) {
      const url = "/products-categories";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = [...this.categories, res.ResponseData];
            self.record.i_t_m1_s_id = res.ResponseData.id;
            self.$refs.snackbar.show("Category Added Successully", "green");
            self.$store.commit("btnLoader", false);
            self.categoryDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (
        this.record.Name !== undefined ||
        this.record.InitialEmpty !== undefined
      ) {
        this.loader = true;
        this.$store.commit("btnLoader", true);
        this.record.SerialStatus = "N";
        this.record.gasProduct = 1;
        this.record.ItemType = "I";
        this.record.ReOrder = 0;
        this.record.SellingPrice = 0;
        this.$emit("data", this.record);
      } else {
        this.$refs.snackbar.show(
          "Product Name or selling price missing!",
          "red"
        );
      }
    },
    updateData() {
      this.loader = true;
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
    setSVolume(id) {
      const data = this.uoms.find((record) => {
        return record.UomEntry === id;
      });
      this.record.SVolume = data.BaseQty;
    },
    setSalUnitMsr(id) {
      const data = this.uoms.find((record) => {
        return record.UomEntry === id;
      });
      this.record.NumInSale = data.BaseQty;
    },
    setInvntryUom(id) {
      const data = this.uoms.find((record) => {
        return record.UomEntry === id;
      });
      this.record.NumInCnt = data.BaseQty;
    },
    setBuyUnitMsr(id) {
      const data = this.uoms.find((record) => {
        return record.UomEntry === id;
      });
      this.record.NumInBuy = data.BaseQty;
    },
    CheckUoMGroup(id) {
      const uomGroup = this.ougp.find((record) => {
        return record.id === id;
      });
      const self = this;
      if (uomGroup.UgpName === "Manual") {
        self.showPricing = false;
        self.manualStatus = true;
      } else {
        this.loading = true;
        this.$store
          .dispatch("get", `/ougp/${id}`)
          .then((res) => {
            self.uoms = res.ResponseData.groupDef;
            self.showPricing = true;
            self.manualStatus = false;
            self.record.SalUnitMsr = null;
            self.loading = false;
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getIndustries() {
      const self = this;
      this.$store
        .dispatch("get", `/industries`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.industries = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getBrands() {
      const self = this;
      this.$store
        .dispatch("get", `/brands`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.brands = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getOugp() {
      const self = this;
      this.$store
        .dispatch("get", `/ougp`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.ougp = res.ResponseData;
            // self.record = { ...self.record, UgpEntry: res.ResponseData[0].id };
            if (self.docCreate == true) {
              self.record.UgpEntry = res.ResponseData[0].id;
              self.record.NumInBuy = 1;
              self.record.NumInSale = 1;
              self.record.NumInBuy = 1;
              // end
              self.showPricing = false;
              self.manualStatus = true;
            }
            // set items per msr
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGeneralSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            // set default store
            if (self.docCreate == true) {
              self.store = res.ResponseData.store_id;
            }
            // set default category
            if (self.record.i_t_m1_s_id == undefined) {
              const brandId = res.ResponseData.defaultBrand;
              const categoryId = res.ResponseData.defaultCategory;
              self.record = {
                ...self.record,
                i_t_m1_s_id: categoryId,
                brand_id: brandId,
                Taxable: "Y",
              };
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSuppliers() {
      const self = this;
      this.$store
        .dispatch("get", `/suppliers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.vendors = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCategories();
    this.getBrands();
    this.getIndustries();
    this.getStores();
    this.getGeneralSettings();
    this.getOugp();
    this.getSuppliers();
  },
};
</script>